export const FORM_TYPES = [
    { key: "music-video", en: "MUSIC VIDEO", fr: "CLIP MUSICAL" },
    { key: "brand-campaign", en: "BRAND CAMPAIGN", fr: "CAMPAGNE DE MARQUE" },
    { key: "film-ads", en: "FILM & ADS", fr: "FILM & PUBLICITÉ" },
    { key: "photography", en: "PHOTOGRAPHY", fr: "PHOTOGRAPHIE" },
    { key: "creative-direction", en: "CREATIVE DIRECTION", fr: "DIRECTION CRÉATIVE" },
    { key: "other", en: "OTHER", fr: "AUTRE" },
];

export const FORM_BUDGETS = [
    { key: "under-1k", en: "UNDER €1K", fr: "MOINS DE 1 000 €" },
    { key: "1-5k", en: "€1K – €5K", fr: "1 000 – 5 000 €" },
    { key: "5-15k", en: "€5K – €15K", fr: "5 000 – 15 000 €" },
    { key: "over-15k", en: "OVER €15K", fr: "PLUS DE 15 000 €" },
    { key: "tbd", en: "TO BE DEFINED", fr: "À DÉFINIR" },
];

export const FORM_TIMELINES = [
    { key: "asap", en: "ASAP", fr: "URGENT" },
    { key: "month", en: "THIS MONTH", fr: "DANS LE MOIS" },
    { key: "quarter", en: "1 – 3 MONTHS", fr: "1 – 3 MOIS" },
    { key: "flexible", en: "FLEXIBLE", fr: "FLEXIBLE" },
];

export const EMAIL = "casper.glm@gloom-ent.ch";

export const NAV = [
    { id: "#work", label: "WORK", testid: "nav-link-work" },
    { id: "#music-videos", label: "CLIPS", testid: "nav-link-clips" },
    { id: "#about", label: "ABOUT", testid: "nav-link-about" },
    { id: "#services", label: "SERVICES", testid: "nav-link-services" },
    { id: "#contact", label: "CONTACT", testid: "nav-link-contact" },
];

export const SOCIALS = [
    { label: "INSTAGRAM — @CASPER.XX6", href: "https://instagram.com/casper.xx6", testid: "social-instagram-casper" },
    { label: "INSTAGRAM — @GLOOMENT.OFFICIEL", href: "https://instagram.com/glooment.officiel", testid: "social-instagram-gloom" },
];

export const CATEGORIES = [
    "ALL",
    "MUSIC VIDEOS",
    "COMMERCIAL",
    "EVENTS",
    "FASHION",
    "PHOTOGRAPHY",
    "CREATIVE DIRECTION",
    "SOCIAL / DIGITAL",
];

export const CAT_FR = {
    "ALL": "TOUS",
    "MUSIC VIDEOS": "CLIPS",
    "COMMERCIAL": "PUBLICITÉ",
    "EVENTS": "ÉVÉNEMENTS",
    "FASHION": "MODE",
    "PHOTOGRAPHY": "PHOTOGRAPHIE",
    "CREATIVE DIRECTION": "DIRECTION CRÉATIVE",
    "SOCIAL / DIGITAL": "SOCIAL / DIGITAL",
};

export const INSTAGRAM = {
    handle: "@casper.xx6",
    url: "https://instagram.com/casper.xx6",
    linktree: "https://linktr.ee/Casper.xx6",
    stats: [
        { days: 7, value: 23000 },
        { days: 14, value: 35000 },
        { days: 30, value: 100000 },
    ],
    monthlyAvg: 100000,
    followers: 3354,
    following: 3113,
    posts: 22,
    accounts: [
        { handle: "@glooment.officiel", url: "https://instagram.com/glooment.officiel" },
        { handle: "@adzif.officiel", url: "https://instagram.com/adzif.officiel" },
        { handle: "@dbc.uhd", url: "https://instagram.com/dbc.uhd" },
        { handle: "@mifx.studio", url: "https://instagram.com/mifx.studio" },
    ],
};

// Secret Project section removed (user request)

export const LOCAL_CLIPS = [
    {
        id: "clip-8oak",
        title: "8OAK",
        client: "GLOOM ENT.",
        year: "2026",
        duration: "1:11",
        img: "/videos/clip-8oak.jpg",
        video: "/videos/clip-8oak.mp4",
    },
    {
        id: "clip-twerk",
        title: "ITS ICY — TWERK",
        client: "GLOOM ENT.",
        year: "2026",
        duration: "0:38",
        img: "/videos/clip-twerk.jpg",
        video: "/videos/clip-twerk.mp4",
    },
];

export const CONCERTS = [
    { id: "davido-1", img: "/img/davido-concert-photo-1.jpg", title: "DAVIDO — LIVE N°1", client: "ABIZWAY × GLOOM ENT.", year: "2026" },
    { id: "davido-2", img: "/img/davido-concert-photo-2.jpg", title: "DAVIDO — LIVE N°2", client: "ABIZWAY × GLOOM ENT.", year: "2026" },
    { id: "davido-3", img: "/img/davido-concert-photo-3.jpg", title: "DAVIDO — LIVE N°3", client: "ABIZWAY × GLOOM ENT.", year: "2026" },
    { id: "davido-4", img: "/img/davido-concert-photo-4.jpg", title: "DAVIDO — LIVE N°4", client: "ABIZWAY × GLOOM ENT.", year: "2026" },
];

export const DAVIDO = {
    featured: {
        id: "davido-live",
        title: "DAVIDO — LIVE FILM",
        client: "ABIZWAY × GLOOM ENT.",
        year: "2026",
        duration: "2:28",
        img: "/videos/davido-concert-live.jpg",
        video: "/videos/davido-concert-live.mp4",
        desc: {
            en: "Full live film — Davido on stage in Zürich, captured and directed by Gloom Ent. for Abizway.",
            fr: "Film live intégral — Davido sur scène à Zürich, capturé et réalisé par Gloom Ent. pour Abizway.",
        },
    },
    reels: [
        {
            id: "davido-reel-1",
            title: "DAVIDO — REEL N°1",
            client: "ABIZWAY × GLOOM ENT.",
            year: "2026",
            duration: "0:07",
            img: "/videos/davido-reel-1.jpg",
            video: "/videos/davido-reel-1.mp4",
        },
        {
            id: "davido-reel-2",
            title: "DAVIDO — REEL N°2",
            client: "ABIZWAY × GLOOM ENT.",
            year: "2026",
            duration: "0:31",
            img: "/videos/davido-reel-2.jpg",
            video: "/videos/davido-reel-2.mp4",
        },
        {
            id: "davido-reel-3",
            title: "DAVIDO — REEL N°3",
            client: "ABIZWAY × GLOOM ENT.",
            year: "2026",
            duration: "0:13",
            img: "/videos/davido-reel-3.jpg",
            video: "/videos/davido-reel-3.mp4",
        },
    ],
};

export const PACKS = [
    {
        id: "pack1",
        name: { en: "PACK 1 — ESSENTIAL", fr: "PACK 1 — ESSENTIEL" },
        price: 750,
        from: { en: "FROM", fr: "DÈS" },
        items: [
            { en: "2H SHOOTING — 2 LOCATIONS", fr: "2H DE TOURNAGE — 2 LIEUX" },
            { en: "TRACK ≤ 2:30", fr: "SON ≤ 2:30" },
            { en: "EDIT — COLOR GRADE — FX — TEASER", fr: "MONTAGE — ÉTALONNAGE — FX — TEASER" },
        ],
    },
    {
        id: "pack2",
        name: { en: "PACK 2 — SIGNATURE", fr: "PACK 2 — SIGNATURE" },
        price: 1200,
        from: { en: "FROM", fr: "DÈS" },
        featured: true,
        items: [
            { en: "4 – 5H SHOOTING — 3 – 4 LOCATIONS", fr: "4 – 5H DE TOURNAGE — 3 – 4 LIEUX" },
            { en: "TRACK ≤ 3:10", fr: "SON ≤ 3:10" },
            { en: "EDIT — COLOR GRADE — FX — TEASERS", fr: "MONTAGE — ÉTALONNAGE — FX — TEASERS" },
        ],
    },
    {
        id: "pack3",
        name: { en: "PACK 3 — PREMIUM", fr: "PACK 3 — PREMIUM" },
        price: 2000,
        from: { en: "FROM", fr: "DÈS" },
        items: [
            { en: "6 – 8H SHOOTING — 5 – 7 LOCATIONS", fr: "6 – 8H DE TOURNAGE — 5 – 7 LIEUX" },
            { en: "TRACK ≤ 4:10 — ART DIRECTION & SCRIPT", fr: "SON ≤ 4:10 — DIRECTION ARTISTIQUE & SCÉNARIO" },
            { en: "EDIT — COLOR GRADE — FX — TEASERS", fr: "MONTAGE — ÉTALONNAGE — FX — TEASERS" },
        ],
    },
];

export const EVENT_PACKS = [
    {
        id: "ev1",
        name: { en: "PRIVATE PARTY / BIRTHDAY", fr: "ANNIVERSAIRE / FÊTE PRIVÉE" },
        price: "1'500 – 5'000+",
        basePrice: 1500,
        items: [
            { en: "EVENING COVERAGE UP TO 6H", fr: "COUVERTURE SOIRÉE JUSQU'À 6H" },
            { en: "1–2 MIN AFTERMOVIE — SOCIAL CUTS", fr: "AFTERMOVIE 1–2 MIN — FORMATS RÉSEAUX" },
            { en: "30+ RETOUCHED PHOTOS", fr: "30+ PHOTOS RETOUCHÉES" },
        ],
    },
    {
        id: "ev2",
        name: { en: "WEDDING", fr: "MARIAGE" },
        price: "2'500 – 4'500",
        basePrice: 2500,
        featured: true,
        items: [
            { en: "FULL DAY — PREPARATIONS TO FIRST DANCE", fr: "JOURNÉE COMPLÈTE — PRÉPARATIFS À L'OUVERTURE DE BAL" },
            { en: "3–5 MIN FILM + HIGHLIGHT TRAILER", fr: "FILM 3–5 MIN + BANDE-ANNONCE" },
            { en: "2 OPERATORS OPTION — DRONE OPTION", fr: "OPTION 2E OPÉRATEUR — OPTION DRONE" },
        ],
    },
    {
        id: "ev3",
        name: { en: "SEMINAR / CORPORATE", fr: "SÉMINAIRE / CORPORATE" },
        price: "2'000 – 5'000+",
        basePrice: 2000,
        items: [
            { en: "MULTI-CAMERA COVERAGE — CONFERENCES, WORKSHOPS", fr: "CAPTATION MULTI-CAMÉRAS — CONFÉRENCES, WORKSHOPS" },
            { en: "REPLAY + AFTERMOVIE + INTERVIEWS", fr: "REPLAY + AFTERMOVIE + INTERVIEWS" },
            { en: "QUOTE BY PROJECT — MULTI-DAY AVAILABLE", fr: "SUR DEVIS — FORMAT MULTI-JOURS POSSIBLE" },
        ],
    },
];

export const GEAR = [
    {
        group: { en: "CAMERA BODIES", fr: "BOÎTIERS" },
        icon: "camera",
        items: [
            { name: "Sony A7R V", spec: { en: "61MP FULL FRAME — 8K", fr: "61 MPX PLEIN FORMAT — 8K" } },
            { name: "Sony ZV-E10", spec: { en: "B-CAM — 4K", fr: "SECOND BOÎTIER — 4K" } },
        ],
    },
    {
        group: { en: "LENSES", fr: "OPTIQUES" },
        icon: "aperture",
        items: [
            { name: "50mm × 2", spec: { en: "PRIMES — LOW LIGHT", fr: "FOCALES FIXES — BASSE LUMIÈRE" } },
            { name: "12mm", spec: { en: "ULTRA WIDE", fr: "ULTRA GRAND-ANGLE" } },
            { name: "10mm", spec: { en: "ULTRA WIDE", fr: "ULTRA GRAND-ANGLE" } },
            { name: "20mm CINE", spec: { en: "CINEMA LENS", fr: "OPTIQUE CINÉMA" } },
        ],
    },
    {
        group: { en: "RIG & POWER", fr: "RIG & ÉNERGIE" },
        icon: "battery",
        items: [
            { name: "Matte Box", spec: { en: "LIGHT CONTROL", fr: "CONTRÔLE LUMIÈRE" } },
            { name: "SmallRig Full Rig", spec: { en: "+ 99WH BATTERY", fr: "+ BATTERIE 99Wh" } },
        ],
    },
    {
        group: { en: "STABILIZATION & AERIAL", fr: "STABILISATION & DRONE" },
        icon: "plane",
        items: [
            { name: "DJI RS 3 Pro Combo", spec: { en: "3-AXIS GIMBAL", fr: "STABILISATEUR 3 AXES" } },
            { name: "DJI Mavic Mini", spec: { en: "DRONE", fr: "DRONE" } },
        ],
    },
    {
        group: { en: "LIGHT & SUPPORTS", fr: "LUMIÈRE & SUPPORTS" },
        icon: "lightbulb",
        items: [
            { name: "LED RGB + FX", spec: { en: "COLORS & EFFECTS", fr: "COULEURS & EFFETS" } },
            { name: "LED Panel", spec: { en: "KEY LIGHT", fr: "PANNEAU LUMIÈRE" } },
            { name: "Tripods 2m30 / 1m80", spec: { en: "TWO TRIPODS", fr: "DEUX TRÉPIEDS" } },
        ],
    },
];

export const FEATURED_IDS = [
    "timelease-reel",
    "resto-faro",
    "clip-nezma",
];

export const PROJECTS = [
    {
        id: "timelease-reel",
        title: "TIME LEASE — REEL",
        client: "TIMELEASE.CH",
        category: "COMMERCIAL",
        year: "2026",
        img: "/videos/timelease-reel.jpg",
        video: "/videos/timelease-reel.mp4",
        duration: "0:27",
        desc: {
            en: "Wide-format reel — the Timelease fleet in motion.",
            fr: "Réel grand format — la flotte Timelease en mouvement.",
        },
    },
    {
        id: "kiosque-bastions",
        title: "NO BAD × KIOSQUE",
        client: "KIOSQUE DES BASTIONS",
        category: "COMMERCIAL",
        year: "2026",
        img: "/videos/work-kiosque.jpg",
        video: "/videos/work-kiosque.mp4",
        duration: "0:43",
        desc: {
            en: "Signature cocktails in motion — social spot with FX for the Kiosque des Bastions, Geneva.",
            fr: "Cocktails signatures en mouvement — spot social avec effets pour le Kiosque des Bastions, Genève.",
        },
    },
    {
        id: "resto-faro",
        title: "FARO — RESTAURANT",
        client: "FARO",
        category: "EVENTS",
        year: "2026",
        img: "/videos/resto-faro.jpg",
        video: "/videos/resto-faro.mp4",
        duration: "0:41",
        desc: {
            en: "Restaurant reel — Faro, room and plates.",
            fr: "Réel restaurant — Faro, salle et assiettes.",
        },
    },
    {
        id: "clip-nezma",
        title: "NEZMA — JSPCF",
        client: "NEZMA",
        category: "MUSIC VIDEOS",
        year: "2026",
        img: "/videos/clip-nezma.jpg",
        video: "/videos/clip-nezma.mp4",
        duration: "1:26",
        desc: {
            en: "Music video — Nezma, JSPCF.",
            fr: "Clip musical — Nezma, JSPCF.",
        },
    },
    {
        id: "sakura-film",
        title: "SAKURA TOURBILLON",
        client: "HORLOGERIE — LUXE",
        category: "COMMERCIAL",
        year: "2026",
        img: "/videos/work-sakura.jpg",
        video: "/videos/work-sakura.mp4",
        duration: "0:14",
        desc: {
            en: "Product film — skeleton tourbillon under falling cherry blossoms, AI-enhanced master.",
            fr: "Film produit — tourbillon squelette sous une pluie de cerisiers, master augmenté par IA.",
        },
    },
    {
        id: "kallykurls-spice-curls",
        title: "SPICE & CURLS",
        client: "",
        category: "COMMERCIAL",
        year: "2026",
        img: "/videos/kallykurls-spice-curls.jpg",
        video: "/videos/kallykurls-spice-curls.mp4",
        duration: "0:17",
        desc: {
            en: "Product film — Spice & Curls by Kally Kurls.",
            fr: "Film produit — Spice & Curls par Kally Kurls.",
        },
    },
    {
        id: "alina-reel",
        title: "ALINA — REEL",
        client: "SOCIAL / LIFESTYLE",
        category: "SOCIAL / DIGITAL",
        year: "2026",
        img: "/videos/work-alina-reel.jpg",
        video: "/videos/work-alina-reel.mp4",
        duration: "0:20",
        desc: {
            en: "Event reel — friends under the rain, vintage grade.",
            fr: "Reel événementiel — souvenirs sous la pluie, étalonnage vintage.",
        },
    },
    {
        id: "hzh-merch",
        title: "HZH — MERCH DROP",
        client: "HZH",
        category: "SOCIAL / DIGITAL",
        year: "2026",
        img: "/videos/work-hzh-merch.jpg",
        video: "/videos/work-hzh-merch.mp4",
        duration: "0:26",
        desc: {
            en: "Streetwear drop — merch pieces, raw handheld energy.",
            fr: "Drop streetwear — pièces merch, énergie brute caméra épaule.",
        },
    },
    {
        id: "event-afterwork",
        title: "AFTER WORK — WE VIBING",
        client: "AFTER WORK",
        category: "EVENTS",
        year: "2026",
        img: "/videos/event-afterwork.jpg",
        video: "/videos/event-afterwork.mp4",
        duration: "0:08",
        desc: {
            en: "Afterwork reel — the vibe after hours.",
            fr: "Réel afterwork — l'ambiance après le travail.",
        },
    },
    {
        id: "event-circus-fonce",
        title: "CIRCUS — AFTER DARK",
        client: "CIRCUS",
        category: "EVENTS",
        year: "2026",
        img: "/videos/event-circus-fonce.jpg",
        video: "/videos/event-circus-fonce.mp4",
        duration: "0:23",
        desc: {
            en: "Club reel — Circus after dark.",
            fr: "Réel club — la nuit Circus.",
        },
    },
    {
        id: "event-boat",
        title: "BOAT PARTY — LÉMAN",
        client: "GLOOM ENT.",
        year: "2026",
        category: "EVENTS",
        video: "/videos/event-boat.mp4",
        img: "/videos/event-boat.jpg",
    },
    {
        id: "event-vice-club",
        title: "VICE CLUB — AFTERMOVIE",
        client: "ABIZWAY",
        category: "EVENTS",
        year: "2026",
        img: "/videos/event-vice-club.jpg",
        video: "/videos/event-vice-club.mp4",
        duration: "2:11",
        desc: {
            en: "Official aftermovie — Vice Club by Abizway.",
            fr: "Aftermovie officiel — Vice Club by Abizway.",
        },
    },
    {
        id: "event-circus-house",
        title: "CIRCUS — HOUSE",
        client: "CIRCUS",
        category: "EVENTS",
        year: "2026",
        img: "/videos/event-circus-house.jpg",
        video: "/videos/event-circus-house.mp4",
        duration: "0:25",
        desc: {
            en: "Club reel — house night at Circus.",
            fr: "Réel club — soirée house au Circus.",
        },
    },
    {
        id: "event-antigel",
        title: "NO BAD × ANTIGEL",
        client: "ANTIGEL",
        category: "EVENTS",
        year: "2026",
        img: "/videos/event-antigel.jpg",
        video: "/videos/event-antigel.mp4",
        duration: "1:00",
        desc: {
            en: "Event reel — No Bad at Antigel.",
            fr: "Réel événement — No Bad à l'Antigel.",
        },
    },
];

export const MUSIC_VIDEOS = [];

export const PHOTO_GROUPS = [
    {
        id: "overdyed",
        title: "OVERDYED",
        sub: { en: "OUTDOOR FASHION SHOW", fr: "DÉFILÉ EN EXTÉRIEUR" },
        kind: "portrait",
        photos: [
            ...Array.from({ length: 18 }, (_, i) => `/img/overdyed-${String(i + 1).padStart(2, "0")}.jpg`),
            ...Array.from({ length: 37 }, (_, i) => {
                const files = [
                    "_DSC8330.jpg","_DSC8347.jpg","_DSC8362.jpg","_DSC8373.jpg","_DSC8375.jpg","_DSC8387.jpg","_DSC8399.jpg","_DSC8406.jpg",
                    "_DSC8438_Edited.jpg","_DSC8455.jpg","_DSC8459.jpg","_DSC8465.jpg","_DSC8490.jpg","_DSC8491.jpg","_DSC8494.jpg","_DSC8495.jpg",
                    "_DSC8505.jpg","_DSC8513.jpg","_DSC8516.jpg","_DSC8518.jpg","_DSC8521.jpg","_DSC8532.jpg","_DSC8536.jpg","_DSC8543.jpg",
                    "_DSC8546.jpg","_DSC8563.jpg","_DSC8564.jpg","_DSC8565.jpg","_DSC8571.jpg","_DSC8573.jpg","_DSC8579.jpg","_DSC8595.jpg",
                    "_DSC8605.jpg","_DSC8636.jpg","IMG_0103.jpg","IMG_0170.jpg","IMG_0171.jpg",
                ];
                return `/img/overdyed2/${files[i]}`;
            }),
        ],
    },
    {
        id: "esquimonoir",
        title: "ESQUIMONOIR",
        sub: { en: "STUDIO — RED SERIES", fr: "STUDIO — SÉRIE ROUGE" },
        kind: "portrait",
        photos: [
            // mises en avant (demande client) : 0632, 0652, 0618, 0619
            "/img/esquimonoir/_DSC0632.jpg",
            "/img/esquimonoir/_DSC0652.jpg",
            "/img/esquimonoir/_DSC0618.jpg",
            "/img/esquimonoir/_DSC0619.jpg",
            "/img/esquimonoir/_DSC0579.jpg",
            "/img/esquimonoir/_DSC0604.jpg",
            "/img/esquimonoir/_DSC0607.jpg",
            "/img/esquimonoir/_DSC0612.jpg",
            "/img/esquimonoir/_DSC0637.jpg",
            "/img/esquimonoir/_DSC0649.jpg",
            "/img/esquimonoir/_DSC0656.jpg",
            ...Array.from({ length: 6 }, (_, i) => `/img/esquimonoir-${String(i + 1).padStart(2, "0")}.jpg`),
        ],
    },
    {
        id: "kallykurls",
        title: "KALLY KURLS",
        sub: { en: "PRODUCT & STUDIO — CURLY SERIES", fr: "PRODUIT & STUDIO — SÉRIE BOUCLÉE" },
        kind: "landscape",
        photos: Array.from({ length: 8 }, (_, i) => `/img/kallykurls-${String(i + 1).padStart(2, "0")}.jpg`),
    },
    {
        id: "theo",
        title: "THÉO",
        sub: { en: "PORTRAIT SERIES", fr: "SÉRIE PORTRAIT" },
        kind: "portrait",
        photos: [
            "/img/theo/THEO_1.jpg",
            "/img/theo/THEO_2.jpg",
            "/img/theo/THEO_4.jpg",
        ],
    },
    {
        id: "hollyg",
        title: "HOLLY G",
        sub: { en: "LIVE CONCERT", fr: "CONCERT LIVE" },
        kind: "mixed",
        photos: [
            "/img/hollyg/DSC01337_1.jpg",
            "/img/hollyg/DSC01455_1.jpg",
            "/img/hollyg/DSC01460_1.jpg",
            "/img/hollyg/DSC01467_1.jpg",
            "/img/hollyg/DSC01476_1.jpg",
            "/img/hollyg/DSC01484_1.jpg",
            "/img/hollyg/DSC01487_1.jpg",
        ],
    },
    {
        id: "sijay-bpm",
        title: "SIJAY — BPM",
        sub: { en: "STUDIO SESSION", fr: "SESSION STUDIO" },
        kind: "portrait",
        photos: [
            "/img/sijay-bpm/DSC00449.jpeg",
            "/img/sijay-bpm/DSC00450.jpeg",
            "/img/sijay-bpm/DSC00452.jpeg",
            "/img/sijay-bpm/DSC00455.jpeg",
            "/img/sijay-bpm/DSC00460.jpeg",
        ],
    },
    {
        id: "instants-figes",
        title: "INSTANTS FIGÉS",
        sub: { en: "SHOOTING 629LA", fr: "SHOOTING 629LA" },
        kind: "portrait",
        photos: [
            "/img/instants-figes/DSC8851.jpg",
            "/img/instants-figes/DSC8855.jpg",
            "/img/instants-figes/DSC8865.jpg",
            "/img/instants-figes/DSC8867.jpg",
            "/img/instants-figes/DSC8870.jpg",
            "/img/instants-figes/DSC8871.jpg",
            "/img/instants-figes/DSC8938.jpg",
            "/img/instants-figes/DSC8967.jpg",
            "/img/instants-figes/DSC8971.jpg",
            "/img/instants-figes/DSC9034.jpg",
            "/img/instants-figes/DSC9044.jpg",
            "/img/instants-figes/DSC9070.jpg",
            "/img/instants-figes/DSC9072.jpg",
            "/img/instants-figes/DSC9076.jpg",
            "/img/instants-figes/DSC9077.jpg",
            "/img/instants-figes/DSC9102.jpg",
            "/img/instants-figes/33994337-1209-40B3-9B4C-DCADFAC3821B.jpg",
            "/img/instants-figes/3DDCA982-B607-4A5F-8992-CB4D1361B1A7.jpg",
        ],
    },
    {
        id: "pnasty",
        title: "PNASTY",
        sub: { en: "STUDIO — ARTIST SERIES", fr: "STUDIO — SÉRIE ARTISTE" },
        kind: "portrait",
        photos: Array.from({ length: 3 }, (_, i) => `/img/pnasty-${String(i + 1).padStart(2, "0")}.jpg`),
    },
    {
        id: "automotive",
        title: "CARS OF TIMELEASE",
        sub: { en: "TIMELEASE.CH", fr: "TIMELEASE.CH" },
        kind: "mixed",
        photos: [
            "/img/car-gt3rs-1.webp",
            "/img/timelease-01.jpg",
            "/img/timelease-04.jpg",
            "/img/car-hurst-1.webp",
            "/img/timelease-02.jpg",
            "/img/timelease-05.jpg",
            "/img/car-gt3rs-2.webp",
            "/img/timelease-03.jpg",
            "/img/car-hurst-2.webp",
            "/img/timelease-06.jpg",
            "/img/timelease-cars/DSC00588.jpeg",
            "/img/timelease-cars/IMG_3884.jpeg",
            "/img/timelease-cars/IMG_3907.jpeg",
            "/img/timelease-cars/IMG_3911.jpeg",
            "/img/timelease-cars/IMG_3912.jpeg",
            "/img/timelease-cars/IMG_3913.jpeg",
            "/img/timelease-cars/IMG_3914.jpeg",
            "/img/timelease-cars/IMG_3915.jpeg",
            "/img/timelease-cars/IMG_3916.jpeg",
        ],
    },
];

export const SERVICES = [
    {
        num: "01",
        title: { en: "CREATIVE DIRECTION", fr: "DIRECTION CRÉATIVE" },
        desc: {
            en: "Visual worlds, art direction and identity for brands and artists.",
            fr: "Univers visuels, direction artistique et identité pour les marques et les artistes.",
        },
    },
    {
        num: "02",
        title: { en: "FILM & VIDEO", fr: "FILM & VIDÉO" },
        desc: {
            en: "Music videos, commercials and films — from treatment to final cut.",
            fr: "Clips, publicités et films — du traitement au montage final.",
        },
    },
    {
        num: "03",
        title: { en: "PHOTOGRAPHY", fr: "PHOTOGRAPHIE" },
        desc: {
            en: "Editorial, fashion and campaign photography with a signature look.",
            fr: "Photographie éditoriale, mode et campagne avec une signature visuelle.",
        },
    },
    {
        num: "04",
        title: { en: "VISUAL MARKETING", fr: "MARKETING VISUEL" },
        desc: {
            en: "Visual strategy that turns attention into desire — and desire into results.",
            fr: "Une stratégie visuelle qui transforme l'attention en désir — et le désir en résultats.",
        },
    },
    {
        num: "05",
        title: { en: "CAMPAIGN STRATEGY", fr: "STRATÉGIE DE CAMPAGNE" },
        desc: {
            en: "Concepts, planning and rollouts across film, social and print.",
            fr: "Concepts, planification et déploiements sur le film, le social et le print.",
        },
    },
    {
        num: "06",
        title: { en: "CONTENT CREATION", fr: "CRÉATION DE CONTENU" },
        desc: {
            en: "High-end content systems for social, digital and OOH.",
            fr: "Des systèmes de contenu haut de gamme pour le social, le digital et l'affichage.",
        },
    },
];

export const STATS = [
    { value: 10, suffix: "+", label: { en: "YEARS", fr: "ANNÉES" } },
    { value: 120, suffix: "+", label: { en: "PROJECTS", fr: "PROJETS" } },
    { value: 150, suffix: "M+", label: { en: "VIEWS", fr: "VUES" } },
    { value: 25, suffix: "", label: { en: "AWARDS", fr: "DISTINCTIONS" } },
];

export const CLIENTS = [
    "MAISON AUBÉ",
    "VELSOR MOTORS",
    "SOLSTICE RECORDS",
    "NOVA REI",
    "KAYO",
    "LÉA NOIR",
    "ATELIER 44",
    "JUNO WAVE",
];

export const EXPERTISE = [
    { en: "CREATIVE DIRECTION", fr: "DIRECTION ARTISTIQUE" },
    { en: "FILM DIRECTION", fr: "RÉALISATION" },
    { en: "PHOTOGRAPHY", fr: "PHOTOGRAPHIE" },
    { en: "VISUAL MARKETING", fr: "MARKETING VISUEL" },
    { en: "DIGITAL STRATEGY", fr: "STRATÉGIE DIGITALE" },
    { en: "INFLUENCER CAMPAIGNS", fr: "CAMPAGNES INFLUENCEURS" },
    { en: "EVENTS", fr: "ÉVÉNEMENTS" },
    { en: "CONTENT CREATION", fr: "CRÉATION DE CONTENU" },
];

export const T = {
    form: {
        title: { en: "START YOUR PROJECT", fr: "DÉMARRER VOTRE PROJET" },
        step: { en: "STEP", fr: "ÉTAPE" },
        of: { en: "OF", fr: "SUR" },
        step1Title: { en: "WHAT ARE WE CREATING?", fr: "QU'ALLONS-NOUS CRÉER ?" },
        step2Title: { en: "SCOPE & TIMING", fr: "PÉRIMÈTRE & DÉLAIS" },
        step3Title: { en: "TELL ME EVERYTHING", fr: "PARLEZ-MOI DE VOTRE PROJET" },
        budget: { en: "BUDGET (OPTIONAL)", fr: "BUDGET (OPTIONNEL)" },
        timeline: { en: "TIMELINE", fr: "DÉLAIS" },
        name: { en: "NAME *", fr: "NOM *" },
        email: { en: "EMAIL *", fr: "EMAIL *" },
        company: { en: "COMPANY / ARTIST (OPTIONAL)", fr: "SOCIÉTÉ / ARTISTE (OPTIONNEL)" },
        message: { en: "YOUR MESSAGE *", fr: "VOTRE MESSAGE *" },
        namePh: { en: "Jane Doe", fr: "Prénom Nom" },
        companyPh: { en: "Brand, label, agency…", fr: "Marque, label, agence…" },
        messagePh: { en: "Brief, vibe, references, dates…", fr: "Brief, ambiance, références, dates…" },
        next: { en: "CONTINUE", fr: "CONTINUER" },
        back: { en: "BACK", fr: "RETOUR" },
        send: { en: "SEND PROJECT", fr: "ENVOYER LE PROJET" },
        sending: { en: "SENDING…", fr: "ENVOI…" },
        errType: { en: "PICK A PROJECT TYPE", fr: "CHOISISSEZ UN TYPE DE PROJET" },
        errName: { en: "YOUR NAME IS REQUIRED", fr: "VOTRE NOM EST REQUIS" },
        errEmail: { en: "A VALID EMAIL IS REQUIRED", fr: "UN EMAIL VALIDE EST REQUIS" },
        errMessage: { en: "TELL ME A BIT MORE", fr: "DITES-M'EN UN PEU PLUS" },
        errSend: { en: "SENDING FAILED — TRY AGAIN", fr: "ÉCHEC DE L'ENVOI — RÉESSAYEZ" },
        successTitle: { en: "MESSAGE SENT.", fr: "MESSAGE ENVOYÉ." },
        successBody: { en: "Thank you — Casper replies within 48 hours.", fr: "Merci — Casper répond sous 48 heures." },
        successReset: { en: "NEW MESSAGE", fr: "NOUVEAU MESSAGE" },
        directTitle: { en: "OR WRITE DIRECTLY", fr: "OU ÉCRIVEZ DIRECTEMENT" },
        aiEnhance: { en: "ENHANCE WITH AI", fr: "AMÉLIORER AVEC L'IA" },
        aiWorking: { en: "AI IS WRITING…", fr: "L'IA RÉDIGE…" },
        aiDone: { en: "BRIEF ENHANCED", fr: "BRIEF AMÉLIORÉ" },
        aiEmpty: { en: "WRITE A DRAFT FIRST", fr: "ÉCRIVEZ D'ABORD UN BROUILLON" },
        aiFail: { en: "AI UNAVAILABLE — TRY AGAIN", fr: "IA INDISPONIBLE — RÉESSAYEZ" },
    },
    chat: {
        online: { en: "ONLINE — AI", fr: "EN LIGNE — IA" },
        inputPh: { en: "Ask a question…", fr: "Posez votre question…" },
        send: { en: "SEND", fr: "ENVOYER" },
    },
    hero: {
        positioning: {
            en: "CREATIVE DIRECTION / FILM / VISUAL MARKETING",
            fr: "DIRECTION ARTISTIQUE / RÉALISATION / MARKETING VISUEL",
        },
        sub: {
            en: "We craft the images people remember — films, photography and campaigns for artists and brands.",
            fr: "Nous créons les images dont on se souvient — films, photographie et campagnes pour artistes et marques.",
        },
        ctaWork: { en: "VIEW WORK", fr: "VOIR LES PROJETS" },
        ctaContact: { en: "GET IN TOUCH", fr: "ME CONTACTER" },
        ctaPricing: { en: "PRICING", fr: "TARIFS" },
        scroll: { en: "SCROLL", fr: "DÉFILER" },
        reel: { en: "SHOWREEL — 2025", fr: "SHOWREEL — 2025" },
        davido: { en: "DAVIDO LIVE — WATCH", fr: "DAVIDO LIVE — REGARDER" },
        available: { en: "AVAILABLE FOR ALL PROJECTS", fr: "DISPONIBLE POUR TOUT PROJET" },
    },
    work: {
        label: { en: "01 — PORTFOLIO", fr: "01 — PORTFOLIO" },
        title: { en: "WORKS", fr: "PROJETS" },
        note: {
            en: "13 FILMS LIVE — MORE PROJECTS COMING",
            fr: "13 FILMS EN LIGNE — D'AUTRES PROJETS ARRIVENT",
        },
        visionLabel: {
            en: "MY VISION — CREATIVE DIRECTION",
            fr: "MA VISION — DIRECTION ARTISTIQUE",
        },
        vision: {
            en: "Creative direction is, above all, a standard. Every frame, every colour, every second must serve a precise intention. My conviction: an emerging artist deserves the same level of professionalism as an established one — a clear vision, a coherent universe, an image that places them exactly where they want to be perceived. We do not make content; we build an identity. That is how you leave a mark on your time.",
            fr: "La direction artistique, c'est d'abord une exigence. Chaque cadre, chaque couleur, chaque seconde doit servir une intention précise. Ma conviction : un artiste émergent mérite le même niveau de professionnalisme qu'un artiste établi — une vision claire, un univers cohérent, une image qui le place directement là où il veut être perçu. On ne fabrique pas du contenu, on construit une identité. C'est comme ça qu'on marque son temps.",
        },
        role: { en: "ROLE", fr: "RÔLE" },
        more: { en: "VIEW ALL VIDEOS", fr: "VOIR TOUTES LES VIDÉOS" },
        allTitle: { en: "ALL VIDEOS", fr: "TOUTES LES VIDÉOS" },
        allNote: { en: "13 FILMS — FULL ARCHIVE", fr: "13 FILMS — ARCHIVE COMPLÈTE" },
        production: { en: "PRODUCTION", fr: "PRODUCTION" },
        duration: { en: "DURATION / SCOPE", fr: "DURÉE / PÉRIMÈTRE" },
    },
    immersive: {
        label: { en: "THE GLOOM EXPERIENCE", fr: "L'EXPÉRIENCE GLOOM" },
        hint: { en: "SCROLL TO DISCOVER THE EXPERIENCE", fr: "SCROLLEZ POUR DÉCOUVRIR L'EXPÉRIENCE" },
        soundOn: { en: "SOUND ON", fr: "SON ON" },
        soundOff: { en: "SOUND", fr: "SON" },
        drag: { en: "GRAB THE ARROW — THROW IT, IT BOUNCES BACK", fr: "ATTRAPEZ LA FLÈCHE — LANCEZ-LA, ELLE REVIENT" },
    },
    laduree: {
        label: { en: "FEATURED PROJECT", fr: "PROJET VEDETTE" },
        note: {
            en: "VISUAL CAMPAIGN — MACARONS, TEXTURE & COLOUR — POSTER + 5 PHOTOGRAPHS",
            fr: "CAMPAGNE VISUELLE — MACARONS, MATIÈRE & COULEUR — AFFICHE + 5 PHOTOGRAPHIES",
        },
        client: { en: "LADURÉE × GLOOM ENT.", fr: "LADURÉE × GLOOM ENT." },
        campaign: { en: "THE MACARON, ELEVATED", fr: "LE MACARON, SUBLIMÉ" },
        poster: { en: "OFFICIAL POSTER", fr: "AFFICHE OFFICIELLE" },
        more: { en: "SEE MORE", fr: "VOIR +" },
    },
    mv: {
        label: { en: "02 — MUSIC VIDEOS", fr: "02 — CLIPS MUSICAUX" },
        title: { en: "VIDEO CLIP", fr: "VIDÉO CLIP" },
        note: {
            en: "7 DIRECTED VIDEOS — SORTED BY VIEWS",
            fr: "7 CLIPS RÉALISÉS — CLASSÉS PAR VUES",
        },
        localLabel: { en: "EXCLUSIVES — NOT ON YOUTUBE", fr: "EXCLUS — CLIPS HORS YOUTUBE" },
        concertsNote: {
            en: "DAVIDO — ABIZWAY 2026 — ZÜRICH — MORE LIVE CONTENT COMING",
            fr: "DAVIDO — ABIZWAY 2026 — ZÜRICH — D'AUTRES CONTENUS LIVE ARRIVENT",
        },
    },
    davido: {
        title: { en: "DAVIDO — LIVE", fr: "DAVIDO — LIVE" },
        note: {
            en: "ABIZWAY 2026 — ZÜRICH — FULL FILM + REELS + CONCERT PHOTOS",
            fr: "ABIZWAY 2026 — ZÜRICH — FILM COMPLET + REELS + PHOTOS CONCERT",
        },
    },
    insta: {
        label: { en: "@CASPER.XX6 — INSTAGRAM", fr: "@CASPER.XX6 — INSTAGRAM" },
        title: { en: "FOLLOW THE VISION", fr: "SUIVEZ LA VISION" },
        sub: {
            en: "ACCOUNT INSIGHTS — REAL ENGAGEMENT ON INSTAGRAM",
            fr: "STATISTIQUES DU COMPTE — ENGAGEMENT RÉEL SUR INSTAGRAM",
        },
        role: {
            en: "ARTISTIC DIRECTOR — GENEVA, SWITZERLAND",
            fr: "DIRECTEUR ARTISTIQUE — GENÈVE, SUISSE",
        },
        verified: { en: "VERIFIED ACCOUNT", fr: "COMPTE VÉRIFIÉ" },
        followers: { en: "FOLLOWERS", fr: "ABONNÉS" },
        posts: { en: "POSTS", fr: "PUBLICATIONS" },
        following: { en: "FOLLOWING", fr: "SUIVI(E)S" },
        realisation: { en: "DIRECTION", fr: "RÉALISATION" },
        follow: { en: "FOLLOW ON INSTAGRAM", fr: "SUIVRE SUR INSTAGRAM" },
        note: {
            en: "SOURCE — INSTAGRAM ACCOUNT INSIGHTS",
            fr: "SOURCE — STATISTIQUES DU COMPTE INSTAGRAM",
        },
        monthly: {
            en: "AVERAGE MONTHLY VIEWS",
            fr: "VUES MENSUELLES EN MOYENNE",
        },
        monthlyNote: {
            en: "BASED ON THE LAST 30 DAYS",
            fr: "CALCULÉ SUR LES 30 DERNIERS JOURS",
        },
    },
    photo: {
        label: { en: "03 — PHOTOGRAPHY", fr: "03 — PHOTOGRAPHIE" },
        title: { en: "STILL FRAMES", fr: "INSTANTS FIGÉS" },
        note: {
            en: "OVERDYED — THÉO — HOLLY G — SIJAY — KALLY KURLS — ESQUIMONOIR — PNASTY — CARS",
            fr: "OVERDYED — THÉO — HOLLY G — SIJAY — KALLY KURLS — ESQUIMONOIR — PNASTY — CARS",
        },
        more: { en: "VIEW FULL SHOOT", fr: "VOIR TOUT LE SHOOTING" },
        less: { en: "SHOW LESS", fr: "VOIR MOINS" },
    },
    empty: {
        work: { en: "YOUR PROJECTS WILL LIVE HERE", fr: "VOS PROJETS ARRIVENT ICI" },
        mv: { en: "YOUR MUSIC VIDEOS WILL LIVE HERE", fr: "VOS CLIPS ARRIVENT ICI" },
        photo: { en: "YOUR PHOTOS WILL LIVE HERE", fr: "VOS PHOTOS ARRIVENT ICI" },
        concert: {
            en: "CONCERTS — YOUR LIVE VIDEOS WILL LIVE HERE",
            fr: "CONCERTS — VOS VIDÉOS LIVE ARRIVENT ICI",
        },
        waiting: { en: "AWAITING YOUR MEDIA", fr: "EN ATTENTE DE VOS MÉDIAS" },
    },
    about: {
        label: { en: "04 — ABOUT", fr: "04 — À PROPOS" },
        statement: {
            en: "I direct images that make people feel before they understand — for artists, brands and houses with something to say.",
            fr: "Je dirige des images qui font ressentir avant de comprendre — pour les artistes et les marques qui ont quelque chose à dire.",
        },
        body: {
            en: "Ten years across creative direction, filmmaking and visual marketing. From music videos and fashion campaigns to influencer strategies and live events — Gloom Ent. builds visual worlds with a single obsession: images that stay.",
            fr: "Dix ans de direction artistique, de réalisation et de marketing visuel. Des clips aux campagnes de mode, des stratégies d'influence aux événements — Gloom Ent. construit des univers visuels avec une seule obsession : des images qui restent.",
        },
        clients: { en: "SELECTED CLIENTS / ARTISTS", fr: "CLIENTS / ARTISTES SÉLECTIONNÉS" },
        gear: { en: "THE ARSENAL", fr: "L'ARSENAL" },
        gearNote: {
            en: "EVERY PRODUCTION FULLY EQUIPPED IN-HOUSE",
            fr: "CHAQUE PRODUCTION ENTIÈREMENT ÉQUIPÉE EN INTERNE",
        },
        portraitCaption: { en: "THE GEAR — SONY A7R V × SMALLRIG", fr: "LE MATÉRIEL — SONY A7R V × SMALLRIG" },
    },
    services: {
        label: { en: "05 — SERVICES", fr: "05 — SERVICES" },
        title: { en: "WHAT I DO", fr: "CE QUE JE FAIS" },
    },
    pricing: {
        label: { en: "06 — RATES", fr: "06 — TARIFS" },
        title: { en: "BASE RATES", fr: "TARIFS DE BASE" },
        note: {
            en: "TRANSPARENT PACKS — ADJUSTED TO YOUR PROJECT",
            fr: "PACKS TRANSPARENTS — AJUSTÉS À VOTRE PROJET",
        },
        popular: { en: "MOST BOOKED", fr: "LE PLUS DEMANDÉ" },
        estTitle: { en: "ESTIMATE YOUR PROJECT", fr: "ESTIMEZ VOTRE PROJET" },
        estSub: {
            en: "5 QUESTIONS — INDICATIVE PRICE, NO COMMITMENT",
            fr: "5 QUESTIONS — PRIX INDICATIF, SANS ENGAGEMENT",
        },
        qDur: { en: "1 — TRACK LENGTH", fr: "1 — DURÉE DU SON" },
        qHours: { en: "2 — APPROX. SHOOTING HOURS", fr: "2 — HEURES DE TOURNAGE (APPROX.)" },
        qLocs: { en: "3 — NUMBER OF LOCATIONS", fr: "3 — NOMBRE DE LIEUX" },
        qDa: { en: "4 — ART DIRECTION NEEDED?", fr: "4 — BESOIN D'UNE DA ?" },
        qRelease: { en: "5 — DESIRED RELEASE DATE", fr: "5 — DATE DE SORTIE SOUHAITÉE" },
        da_no: { en: "NO", fr: "NON" },
        da_light: { en: "IDEAS + LOCATIONS", fr: "IDÉES + LIEUX" },
        da_full: { en: "FULL DA + SCRIPT", fr: "DA COMPLÈTE + SCÉNARIO" },
        optLocs: { en: "LOCATIONS", fr: "LIEUX" },
        optDur: { en: "TRACK", fr: "SON" },
        optDa: { en: "ART DIRECTION", fr: "DIRECTION ARTISTIQUE" },
        estResult: { en: "INDICATIVE PRICE", fr: "PRIX INDICATIF" },
        disclaimer: {
            en: "INDICATIVE PRICE — FINAL QUOTE AFTER BRIEF. PAYMENT: 50% ON BOOKING, 50% ON SHOOT DAY.",
            fr: "PRIX INDICATIF — DEVIS FINAL APRÈS BRIEF. PAIEMENT : 50% À LA RÉSERVATION, 50% LE JOUR DU TOURNAGE.",
        },
        eventsLabel: { en: "06B — EVENTS", fr: "06B — ÉVÉNEMENTS" },
        eventsTitle: { en: "EVENTS & WEDDINGS", fr: "ÉVÉNEMENTS & MARIAGES" },
        cadrageLabel: { en: "CADRAGE ONLY", fr: "CADRAGE UNIQUEMENT" },
        cadrageTitle: { en: "FILMING ONLY — 180 CHF/H", fr: "CADRAGE UNIQUEMENT — 180 CHF/H" },
        cadrageSub: {
            en: "SHOOTING ONLY — CAMERA OPERATOR + GEAR. EDITING & LICENSE NOT INCLUDED. IMAGE RIGHTS: +200% OF THE RATE.",
            fr: "TOURNAGE SEUL — OPÉRATEUR + MATÉRIEL. MONTAGE & LICENCE NON INCLUS. DROITS D'IMAGE : +200% DU TARIF.",
        },
        cadrageExample: {
            en: "EXAMPLE — PACK 1 (750 CHF): WITHOUT RIGHTS = 750 CHF · WITH FULL RIGHTS (+200% = 1'500 CHF) = TOTAL 2'250 CHF",
            fr: "EXEMPLE — PACK 1 (750 CHF) : SANS DROITS = 750 CHF · AVEC CESSION INTÉGRALE (+200% = 1'500 CHF) = TOTAL 2'250 CHF",
        },
        rightsTitle: { en: "EXPLOITATION & IMAGE USE RIGHTS", fr: "DROITS D'EXPLOITATION ET UTILISATION DES IMAGES" },
        rightsBase: {
            en: "The base rate covers the creation of your audiovisual project: filming, equipment and editing, plus a standard licence allowing the final clip to be broadcast on your own platforms.",
            fr: "Le tarif de base comprend la création de votre projet audiovisuel : tournage, matériel et montage, ainsi qu'une licence standard permettant la diffusion du clip final sur vos propres plateformes.",
        },
        rightsFullTitle: { en: "FULL RIGHTS TRANSFER — +200%", fr: "CESSION INTÉGRALE DES DROITS D'EXPLOITATION — +200%" },
        rightsFullIntro: {
            en: "The full transfer of exploitation rights gives you extended freedom in the use of your project. It includes:",
            fr: "La cession intégrale des droits d'exploitation vous permet de disposer d'une liberté étendue dans l'utilisation de votre projet. Elle comprend notamment :",
        },
        rightsFullItems: [
            { en: "Delivery of raw footage and source video files.", fr: "La remise des rushes et fichiers vidéo bruts." },
            { en: "The right to have the footage modified or re-edited by another professional.", fr: "Le droit de faire modifier ou remonter les images par un autre professionnel." },
            { en: "The right to transfer the files to a label, agency or partner.", fr: "Le droit de transmettre les fichiers à un label, une agence ou un partenaire." },
            { en: "The right to exploit, market and use the footage for promotional or advertising purposes, as agreed.", fr: "Le droit d'exploiter, commercialiser et utiliser les images à des fins promotionnelles ou publicitaires, selon les conditions convenues." },
        ],
        rightsFullNote: {
            en: "This option represents a supplement of 200% of the initial rate, i.e. a total amount equivalent to 300% of the base price.",
            fr: "Cette option représente un supplément de 200 % du tarif initial, soit un montant total équivalent à 300 % du prix de base.",
        },
        rightsProcessTitle: { en: "VALIDATION & DELIVERY PROCESS", fr: "PROCESSUS DE VALIDATION ET DE LIVRAISON" },
        rightsProcess: {
            en: "The final project is submitted for your approval before definitive delivery. Once the edit is approved and full payment made, the agreed files are delivered. In case of full rights transfer, the agreed rushes and source files are also delivered after validation and payment of the supplement. Any modification request after validation, as well as any additional service, may be subject to additional billing.",
            fr: "Le projet final est soumis à votre validation avant sa livraison définitive. Une fois le montage approuvé et le paiement intégral effectué, les fichiers prévus dans la prestation sont livrés au client. En cas de cession intégrale des droits d'exploitation, les rushes et fichiers sources convenus sont également remis après validation et règlement du supplément correspondant. Toute demande de modification après validation, ainsi que toute prestation supplémentaire, pourra faire l'objet d'une facturation complémentaire.",
        },
        rightsWhyTitle: { en: "WHY THIS SUPPLEMENT?", fr: "POURQUOI CE SUPPLÉMENT ?" },
        rightsWhy: {
            en: "The production rate pays for the making of your project. The full rights transfer covers the commercial value of your footage and the freedom of exploitation granted beyond simple broadcast. Without this option, the footage remains under the standard licence and may not be freely modified, resold or exploited by third parties. Any full transfer must be agreed in writing.",
            fr: "Le tarif de production rémunère la réalisation de votre projet. La cession intégrale des droits couvre, quant à elle, la valeur commerciale de vos images et la liberté d'exploitation accordée au-delà de leur simple diffusion. Sans cette option, les images restent soumises à la licence standard et ne peuvent être librement modifiées, revendues ou exploitées par des tiers. Toute cession intégrale doit être convenue par écrit.",
        },
        rightsChoiceYes: { en: "WITH FULL RIGHTS (+200%)", fr: "AVEC DROITS COMPLETS (+200%)" },
        rightsChoiceNo: { en: "WITHOUT (STANDARD LICENCE)", fr: "SANS (LICENCE STANDARD)" },
        rightsTotal: { en: "TOTAL", fr: "TOTAL" },
        eventsNote: {
            en: "QUOTED BY PROJECT — DEPENDING ON DURATION, CREW & DELIVERABLES",
            fr: "SUR DEVIS — SELON DURÉE, ÉQUIPE & LIVRABLES",
        },
        deposit: {
            en: "DATE LOCKED ON DEPOSIT — SECURE CARD PAYMENT (STRIPE)",
            fr: "DATE BLOQUÉE SUR ACOMPTE — PAIEMENT CARTE SÉCURISÉ (STRIPE)",
        },
        pay: { en: "PAY DEPOSIT", fr: "PAYER" },
        payEvent: { en: "PAY / BOOK NOW", fr: "PAYER / RÉSERVER" },
        adsLabel: { en: "ALSO — PERFORMANCE MARKETING", fr: "AUSSI — MARKETING DE PERFORMANCE" },
        adsTitle: { en: "GOOGLE ADS & YOUTUBE ADS", fr: "GOOGLE ADS & YOUTUBE ADS" },
        adsBody: {
            en: "We also manage your Google Ads and YouTube Ads campaigns: strategy, targeting, creatives and optimization to turn views into bookings.",
            fr: "Nous gérons aussi vos campagnes Google Ads et YouTube Ads : stratégie, ciblage, créas et optimisation pour transformer les vues en réservations.",
        },
        adsTags: { en: "GOOGLE ADS — YOUTUBE ADS — STRATEGY — CREATIVES", fr: "GOOGLE ADS — YOUTUBE ADS — STRATÉGIE — CRÉAS" },
        wedding: { en: "WEDDING", fr: "MARIAGE" },
        weddingPrice: { en: "≈ CHF 2'500.-", fr: "≈ CHF 2'500.-" },
        weddingNote: {
            en: "FULL DAY — FILM + HIGHLIGHTS + TEASER",
            fr: "JOURNÉE COMPLÈTE — FILM + HIGHLIGHTS + TEASER",
        },
        commercial: { en: "COMMERCIAL VIDEO", fr: "VIDÉO COMMERCIALE" },
        commercialPrice: { en: "≈ CHF 3'000.-", fr: "≈ CHF 3'000.-" },
        commercialNote: {
            en: "EXCL. IMAGE RIGHTS — QUOTE ON BRIEF",
            fr: "HORS DROITS À L'IMAGE — DEVIS SUR BRIEF",
        },
    },
    nav: {
        home: { en: "HOME", fr: "ACCUEIL" },
        videos: { en: "VIDEOS", fr: "VIDÉOS" },
        photo: { en: "PHOTO", fr: "PHOTO" },
        pricing: { en: "RATES", fr: "TARIFS" },
        login: { en: "SIGN IN", fr: "SE CONNECTER" },
    },
    nav: {
        home: { en: "HOME", fr: "ACCUEIL" },
        videos: { en: "VIDEOS", fr: "VIDÉOS" },
        photo: { en: "PHOTO", fr: "PHOTO" },
        pricing: { en: "RATES", fr: "TARIFS" },
        login: { en: "SIGN IN", fr: "SE CONNECTER" },
        portal: { en: "MY SPACE", fr: "MON ESPACE" },
        culture: { en: "CULTURE", fr: "CULTURE" },
        scoreboard: { en: "TOP 10 CH", fr: "TOP 10 CH" },
        artists: { en: "ARTISTS", fr: "ARTISTES" },
        creator: { en: "CREATOR", fr: "CRÉATEUR" },
    },
    pagenav: {
        next: { en: "NEXT PAGE", fr: "PAGE SUIVANTE" },
        home: { en: "HOME", fr: "ACCUEIL" },
        back: { en: "BACK", fr: "RETOUR" },
        top: { en: "TOP OF PAGE", fr: "HAUT DE PAGE" },
    },
    culture: {
        label: { en: "09 — CULTURE", fr: "09 — CULTURE" },
        title: { en: "SWISS HIP-HOP CULTURE", fr: "CULTURE HIP-HOP SUISSE" },
        intro: {
            en: "Switzerland has one of the most vibrant hip-hop and art scenes in Europe — and GLM Radio exists to put its artists forward.",
            fr: "La Suisse possède l'une des scènes hip-hop et artistiques les plus vivantes d'Europe — et GLM Radio existe pour mettre ses artistes en avant.",
        },
        points: [
            {
                title: { en: "A LIVING SCENE", fr: "UNE SCÈNE VIVANTE" },
                body: {
                    en: "From Geneva to Zurich, Lausanne to Basel — and Biel/Bienne, the bilingual city with one of the most active hip-hop scenes in the country. Rap, dancehall and R&B in French, German, Italian and dialects. A culture built in studios, block parties and independent labels — and defended on the airwaves of Couleur 3 (Nayuno) and Tataki (RTS).",
                    fr: "De Genève à Zurich, de Lausanne à Bâle — et Bienne, ville bilingue à la scène hip-hop parmi les plus actives du pays. Rap, dancehall et R&B en français, en allemand, en italien et en dialectes. Une culture construite dans les studios, les block parties et les labels indépendants — et défendue sur les ondes de Couleur 3 (Nayuno) et de Tataki (RTS).",
                },
            },
            {
                title: { en: "SWISS ARTISTS FIRST", fr: "LES ARTISTES SUISSES D'ABORD" },
                body: {
                    en: "On GLM Radio, Swiss artists are highlighted: every track submitted is listened to and validated by Gloom Ent. before broadcast. No ads, no algorithms deciding for you.",
                    fr: "Sur GLM Radio, ce sont les artistes suisses qui sont mis en valeur : chaque morceau proposé est écouté et validé par Gloom Ent. avant diffusion. Pas de pub, pas d'algorithme qui décide à votre place.",
                },
            },
            {
                title: { en: "BY ARTISTS, FOR ARTISTS", fr: "PAR DES ARTISTES, POUR DES ARTISTES" },
                body: {
                    en: "GLM Radio belongs to the artists: they feed it, they grow it. Submit your track, claim your profile, share your Spotify and YouTube links — the stage is yours.",
                    fr: "GLM Radio appartient aux artistes : ce sont eux qui l'alimentent et la font grandir. Proposez votre son, créez votre profil, partagez vos liens Spotify et YouTube — la scène est à vous.",
                },
            },
            {
                title: { en: "UNMATCHED ON STAGE", fr: "IMPACT SUR SCÈNE" },
                body: {
                    en: "Nobody sets a stage on fire like Swiss artists. Makala, Slimka, Daejmy, Al-Walid, Supremnova — their concerts are events, and the Swiss crowd answers every time. The live impact of Swiss rap has nothing to envy anyone.",
                    fr: "Personne n'est chaud comme les artistes suisses sur scène. Makala, Slimka, Daejmy, Al-Walid, Supremnova — leurs concerts sont des événements, et le public suisse répond présent à chaque fois. L'impact live du rap suisse n'a rien à envier à personne.",
                },
            },
        ],
        tabCulture: { en: "CULTURE", fr: "CULTURE" },
        tabChart: { en: "TOP 10 CH", fr: "TOP 10 CH" },
        tabArticles: { en: "ARTICLES", fr: "ARTICLES" },
        tarifs: { en: "PRICING / QUOTE", fr: "TARIFS / DEVIS" },
        chartTitle: { en: "TOP 10 SWISS ARTISTS", fr: "TOP 10 ARTISTES SUISSES" },
        chartSub: {
            en: "SWISS ARTISTS SELECTED BY GLOOM — RANKED EVERY WEEK ON REAL DATA: VIEWS OF THE LATEST VIDEO ON THEIR OWN CHANNEL. APPLE MUSIC EXCERPTS.",
            fr: "ARTISTES SUISSES SÉLECTIONNÉS PAR GLOOM — CLASSÉS CHAQUE SEMAINE SUR DONNÉES RÉELLES : VUES DU DERNIER CLIP DE LEUR CHAÎNE. EXTRAITS APPLE MUSIC.",
        },
        excerpt: { en: "AUDIO EXCERPT", fr: "EXTRAIT AUDIO" },
        watch: { en: "WATCH THE LATEST VIDEO", fr: "VOIR LE DERNIER CLIP" },
        views: { en: "VIEWS", fr: "VUES" },
        updated: { en: "UPDATED ON", fr: "MIS À JOUR LE" },
        loading: { en: "LOADING THE CHART…", fr: "CHARGEMENT DU CLASSEMENT…" },
        more: { en: "READ MORE", fr: "LIRE LA SUITE" },
        less: { en: "CLOSE", fr: "FERMER" },
        articlesTitle: { en: "THE WEEK IN SWISS RAP", fr: "LA SEMAINE DU RAP SUISSE" },
        articlesSub: {
            en: "3 ARTICLES EVERY WEEK — SWISS ARTISTS, THEIR LATEST VIDEOS, BROADCAST HERE.",
            fr: "3 ARTICLES PAR SEMAINE — DES ARTISTES SUISSES, LEUR DERNIER CLIP DIFFUSÉ ICI.",
        },
        articlesEmpty: { en: "FIRST ARTICLES ARRIVE MONDAY", fr: "LES PREMIERS ARTICLES ARRIVENT LUNDI" },
        cta: { en: "LISTEN TO GLM RADIO", fr: "ÉCOUTER GLM RADIO" },
        share: { en: "SHARE THE TOP 10", fr: "PARTAGER LE TOP 10" },
    },
    vip: {
        label: { en: "VIP — PRIVATE EVENT", fr: "VIP — EVENT PRIVÉ" },
        title: { en: "YOUR VIP PASS", fr: "VOTRE BILLET VIP" },
        sub: {
            en: "GOLDEN TICKET — UNIQUE QR CODE — SENT BY EMAIL",
            fr: "BILLET D'OR — QR CODE UNIQUE — ENVOYÉ PAR EMAIL",
        },
        firstName: { en: "FIRST NAME", fr: "PRÉNOM" },
        lastName: { en: "LAST NAME", fr: "NOM" },
        email: { en: "EMAIL — THE TICKET WILL BE SENT TO YOU", fr: "EMAIL — LE BILLET VOUS SERA ENVOYÉ" },
        claim: { en: "CLAIM MY VIP PASS", fr: "RÉCLAMER MON BILLET" },
        note: { en: "UNIQUE — NOMINATIVE — FREE", fr: "UNIQUE — NOMINATIF — GRATUIT" },
        success: { en: "YOUR VIP PASS IS READY", fr: "VOTRE BILLET VIP EST PRÊT" },
        emailSent: { en: "SENT TO YOUR EMAIL", fr: "ENVOYÉ SUR VOTRE EMAIL" },
        emailLater: { en: "EMAIL DELIVERY MAY TAKE A MOMENT — KEEP YOUR CODE", fr: "L'EMAIL PEUT PRENDRE UN MOMENT — GARDEZ VOTRE CODE" },
        err: { en: "PLEASE FILL ALL FIELDS", fr: "REMPLISSEZ TOUS LES CHAMPS" },
        errServer: { en: "ERROR — TRY AGAIN", fr: "ERREUR — RÉESSAYEZ" },
    },
    artists: {
        label: { en: "GLOOM ARTISTS", fr: "ARTISTES GLOOM" },
        title: { en: "PRODUCED BY GLOOM", fr: "PRODUITS PAR GLOOM" },
        sub: {
            en: "PERSONAL PAGES FOR THE ARTISTS WE PRODUCE — CLIPS, LINKS, EXCLUSIVE DISCOUNTS.",
            fr: "PAGES PERSONNELLES DES ARTISTES QUE NOUS PRODUISONS — CLIPS, LIENS, RABAIS EXCLUSIFS.",
        },
        roster: { en: "THE ROSTER", fr: "LE ROSTER" },
        myProfile: { en: "YOUR ARTIST PAGE", fr: "VOTRE PAGE ARTISTE" },
        claimTitle: { en: "ARE YOU ONE OF THEM?", fr: "VOUS EN FAITES PARTIE ?" },
        claimSub: {
            en: "SIGN IN, THEN CLAIM YOUR PRE-BUILT PAGE WITH YOUR ARTIST NAME + INSTAGRAM + LINK OF YOUR LAST GLOOM CLIP.",
            fr: "CONNECTEZ-VOUS, PUIS RÉCLAMEZ VOTRE PAGE PRÉ-CRÉÉE AVEC VOTRE NOM D'ARTISTE + INSTAGRAM + LIEN DE VOTRE DERNIER CLIP GLOOM.",
        },
        firstName: { en: "FIRST NAME", fr: "PRÉNOM" },
        lastName: { en: "LAST NAME", fr: "NOM" },
        pickArtist: { en: "YOUR ARTIST NAME…", fr: "VOTRE NOM D'ARTISTE…" },
        instagram: { en: "INSTAGRAM (@…)", fr: "INSTAGRAM (@…)" },
        youtubeLink: { en: "YOUTUBE LINK OF YOUR LAST GLOOM CLIP", fr: "LIEN YOUTUBE DE VOTRE DERNIER CLIP GLOOM" },
        claimBtn: { en: "CLAIM MY PAGE", fr: "RÉCLAMER MA PAGE" },
        gloomArtist: { en: "GLOOM ENT. ARTIST", fr: "ARTISTE GLOOM ENT." },
        discount: {
            en: "EXCLUSIVE — YOU GET −30% ON THE BIGGEST SHOOTING PACK, FOREVER.",
            fr: "EXCLUSIF — VOUS BÉNÉFICIEZ DE −30% SUR LE PLUS GROS PACK DE TOURNAGE, À VIE.",
        },
        claimedTag: { en: "CLAIMED", fr: "RÉCLAMÉ" },
        err: { en: "PLEASE FILL ALL FIELDS", fr: "REMPLISSEZ TOUS LES CHAMPS" },
        wrongAnswer: { en: "WRONG ANSWER — TRY AGAIN", fr: "MAUVAISE RÉPONSE — RÉESSAYEZ" },
        notRoster: { en: "THIS ARTIST NAME IS NOT IN THE GLOOM ROSTER", fr: "CE NOM D'ARTISTE N'EST PAS DANS LE ROSTER GLOOM" },
        errServer: { en: "ERROR — TRY AGAIN", fr: "ERREUR — RÉESSAYEZ" },
    },
    score: {
        label: { en: "10 — SCOREBOARD", fr: "10 — CLASSEMENT" },
        title: { en: "TOP 5 SWISS ARTISTS", fr: "TOP 5 ARTISTES SUISSES" },
        sub: {
            en: "RANKED BY TOTAL VIEWS OF THEIR CLIPS PRODUCED BY GLOOM ENT. — LIVE YOUTUBE DATA",
            fr: "CLASSÉS PAR VUES TOTALES DE LEURS CLIPS PRODUITS PAR GLOOM ENT. — DONNÉES YOUTUBE EN DIRECT",
        },
        artist: { en: "ARTIST", fr: "ARTISTE" },
        clips: { en: "CLIPS", fr: "CLIPS" },
        views: { en: "VIEWS", fr: "VUES" },
    },
    admin: {
        label: { en: "PRIVATE AREA", fr: "ESPACE PRIVÉ" },
        title: { en: "ADMIN", fr: "ADMIN" },
        login: { en: "SIGN IN WITH GOOGLE", fr: "SE CONNECTER AVEC GOOGLE" },
        denied: { en: "ACCESS RESTRICTED", fr: "ACCÈS RÉSERVÉ" },
        bookings: { en: "BOOKINGS", fr: "RÉSERVATIONS" },
        registrations: { en: "INVESTOR SIGNUPS", fr: "INSCRIPTIONS INVESTISSEURS" },
        contacts: { en: "CONTACT MESSAGES", fr: "MESSAGES CONTACT" },
        logout: { en: "SIGN OUT", fr: "SE DÉCONNECTER" },
        submissions: { en: "RADIO SUBMISSIONS", fr: "SOUMISSIONS RADIO" },
        projects: { en: "CLIENT PROJECTS", fr: "PROJETS CLIENTS" },
        approve: { en: "APPROVE", fr: "VALIDER" },
        pending: { en: "PENDING", fr: "EN ATTENTE" },
        addProject: { en: "ADD PROJECT", fr: "AJOUTER UN PROJET" },
        newProject: { en: "PROJECT NAME", fr: "NOM DU PROJET" },
        clientEmail: { en: "CLIENT EMAIL", fr: "EMAIL CLIENT" },
        stage: { en: "STAGE", fr: "ÉTAPE" },
        projectStages: [
            { en: "BRIEF", fr: "BRIEF" },
            { en: "SHOOTING", fr: "TOURNAGE" },
            { en: "EDITING", fr: "MONTAGE" },
            { en: "COLOR GRADE", fr: "ÉTALONNAGE" },
            { en: "DELIVERY", fr: "LIVRAISON" },
        ],
    },
    radio: {
        label: { en: "08 — GLM RADIO", fr: "08 — GLM RADIO" },
        title: { en: "GLM RADIO", fr: "GLM RADIO" },
        tagline: {
            en: "THE ARTISTS' RADIO — BY GLOOM ENT.",
            fr: "LA RADIO DES ARTISTES — PAR GLOOM ENT.",
        },
        note: {
            en: "Search YouTube, listen here. Artists: submit your track — validated by Gloom Ent.",
            fr: "Cherchez sur YouTube, écoutez ici. Artistes : proposez votre son — validé par Gloom Ent.",
        },
        searchPlaceholder: { en: "SEARCH A TRACK ON YOUTUBE…", fr: "CHERCHER UN SON SUR YOUTUBE…" },
        submitTitle: { en: "SUBMIT YOUR TRACK", fr: "PROPOSEZ VOTRE SON" },
        submitNote: {
            en: "Free — validated by Gloom Ent. before broadcast.",
            fr: "Gratuit — validé par Gloom Ent. avant diffusion.",
        },
        artist: { en: "ARTIST NAME", fr: "NOM D'ARTISTE" },
        trackTitle: { en: "TRACK TITLE", fr: "TITRE DU SON" },
        link: { en: "YOUTUBE / SPOTIFY LINK", fr: "LIEN YOUTUBE / SPOTIFY" },
        spotify: { en: "SPOTIFY TRACK URL (OPTIONAL)", fr: "LIEN SPOTIFY (OPTIONNEL)" },
        contact: { en: "YOUR EMAIL (OPTIONAL)", fr: "VOTRE EMAIL (OPTIONNEL)" },
        submitBtn: { en: "SEND TO GLOOM", fr: "ENVOYER À GLOOM" },
        sent: { en: "TRACK SUBMITTED — WE'LL REVIEW IT", fr: "SON ENVOYÉ — ON L'ÉCOUTE" },
        playing: { en: "NOW PLAYING", fr: "EN ÉCOUTE" },
        spotifyTitle: { en: "STREAM ON SPOTIFY", fr: "ÉCOUTER SUR SPOTIFY" },
        spotifyNote: { en: "EVERY STREAM COUNTS FOR THE ARTIST — OPENS SPOTIFY", fr: "CHAQUE ÉCOUTE COMPTE POUR L'ARTISTE — OUVRE SPOTIFY" },
    },
    portal: {
        label: { en: "MY SPACE", fr: "MON ESPACE" },
        title: { en: "YOUR PROJECT", fr: "VOTRE PROJET" },
        loginTitle: { en: "SIGN IN", fr: "CONNEXION" },
        signin: {
            en: "Sign in with Google to access your personal portal.",
            fr: "Connectez-vous avec Google pour accéder à votre espace personnel.",
        },
        chatTitle: { en: "DISCUSS YOUR PROJECT", fr: "DISCUTEZ DE VOTRE PROJET" },
        chatNote: { en: "OUR AI WILL SUMMARIZE IT FOR CASPER", fr: "NOTRE IA FERA UN COMPTE RENDU À CASPER" },
        chatNote: {
            en: "Describe your idea in simple words — our AI assistant refines it with you and can write your moodboard.",
            fr: "Décrivez votre idée en mots simples — notre assistant IA la précise avec vous et peut rédiger votre moodboard.",
        },
        placeholder: { en: "YOUR MESSAGE…", fr: "VOTRE MESSAGE…" },
        send: { en: "SEND", fr: "ENVOYER" },
        summary: { en: "SEND SUMMARY TO GLOOM", fr: "ENVOYER LE RÉSUMÉ À GLOOM" },
        summarySent: { en: "SUMMARY SENT", fr: "RÉSUMÉ ENVOYÉ" },
        progressTitle: { en: "PROGRESS", fr: "AVANCÉE" },
        noProject: {
            en: "No project yet — book a date or contact us to get started.",
            fr: "Pas encore de projet — réservez une date ou contactez-nous pour démarrer.",
        },
    },
    booking: {
        label: { en: "07 — AVAILABILITY", fr: "07 — DISPONIBILITÉS" },
        title: { en: "BOOK A DATE", fr: "RÉSERVEZ UNE DATE" },
        note: {
            en: "ALL DATES FREE FROM NOV 1ST — EXCEPT DEC 25 & JAN 1",
            fr: "TOUTES DATES LIBRES DÈS LE 1ER NOV. — SAUF 25 DÉC. & 1ER JAN.",
        },
        pick: { en: "PICK A FREE DATE ON THE CALENDAR", fr: "CHOISISSEZ UNE DATE LIBRE SUR LE CALENDRIER" },
        free: { en: "FREE", fr: "LIBRE" },
        picked: { en: "SELECTED", fr: "CHOISI" },
        taken: { en: "TAKEN", fr: "PRIS" },
        fName: { en: "NAME", fr: "NOM" },
        fEmail: { en: "EMAIL", fr: "EMAIL" },
        fBudget: { en: "ESTIMATED BUDGET", fr: "BUDGET ESTIMÉ" },
        fInsta: { en: "YOUR INSTAGRAM (@…)", fr: "VOTRE INSTAGRAM (@…)" },
        submit: { en: "BOOK THIS DATE", fr: "RÉSERVER CETTE DATE" },
        done: { en: "DATE BOOKED", fr: "DATE RÉSERVÉE" },
        gcal: { en: "ADD TO GOOGLE CALENDAR", fr: "AJOUTER À GOOGLE CALENDAR" },
        depositTitle: { en: "LOCK YOUR DATE — DEPOSIT", fr: "BLOQUEZ VOTRE DATE — ACOMPTE" },
        payCard: { en: "PAY DEPOSIT BY CARD", fr: "PAYER L'ACOMPTE PAR CARTE" },
    },
    contact: {
        label: { en: "07 — CONTACT", fr: "07 — CONTACT" },
        title1: { en: "LET'S CREATE", fr: "CRÉONS" },
        title2: { en: "something.", fr: "quelque chose." },
        sub: {
            en: "Tell me about your project — I answer within 48 hours.",
            fr: "Parlez-moi de votre projet — réponse sous 48 heures.",
        },
        copy: { en: "COPY EMAIL", fr: "COPIER L'EMAIL" },
        copied: { en: "EMAIL COPIED — TALK SOON", fr: "EMAIL COPIÉ — À TRÈS VITE" },
        start: { en: "START A PROJECT", fr: "DÉMARRER UN PROJET" },
        top: { en: "BACK TO TOP", fr: "HAUT DE PAGE" },
    },
    menu: { open: { en: "MENU", fr: "MENU" }, close: { en: "CLOSE", fr: "FERMER" } },
};
